import jQuery from "jquery";

jQuery(function ($) {
	'use strict';

	$('[data-p360-qs]').each(function () {
		var list = this;
		var items = [].slice.call(list.querySelectorAll('.question-stack__item'));
		if (!items.length) {
			return;
		}

		function setState(item, open) {
			var btn = item.querySelector('.question-stack__q');
			var panel = item.querySelector('.question-stack__a');
			item.classList.toggle('is-open', open);
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			panel.setAttribute('aria-hidden', open ? 'false' : 'true');
		}

		function close(except) {
			items.forEach(function (item) {
				if (item !== except) {
					setState(item, false);
				}
			});
		}

		function toggle(item) {
			var open = !item.classList.contains('is-open');
			close(item);
			setState(item, open);
		}

		items.forEach(function (item) {
			var btn = item.querySelector('.question-stack__q');
			btn.addEventListener('click', function () {
				toggle(item);
			});
			btn.addEventListener('keydown', function (e) {
				if (e.key === 'Escape') {
					close(null);
					btn.blur();
				}
			});
		});
	});
});